import React, { useContext } from 'react';

import { DispensaryAccountReviewWithData, PeerGroupPeriodSummary, PeriodSummary } from '@gcv/shared';
import { GcvChart } from './GcvChart';
import { VerticalBarConfig } from './chart-options';
import { tooltip } from './Tooltip';
import { formatChangePercentage, formatMoney, formatPercentage } from 'libs/react-ui/src/util';
import { AccountMonitoringContext } from '../../account-monitoring-context';

interface Props {
  review: DispensaryAccountReviewWithData;
}

export const SalesSummaryWholesaleSalesChart: React.FC<Props> = props => {
  const context = useContext(AccountMonitoringContext);
  return <GcvChart type="verticalBar" config={chartDataAdapter(props.review, context.peerGroupId)} />;
};

export const chartDataAdapter = (review: DispensaryAccountReviewWithData, peerGroupId: string) => {
  return dataAdapter(review.data.aggregated_sales_data, peerGroupId);
};

export const dataAdapter = (
  data: {
    current_period: PeriodSummary;
    previous_period: PeriodSummary;
    previous_year: PeriodSummary;
    peer_groups: {
      [id: string]: PeerGroupPeriodSummary;
    };
  },
  peerGroupId: string
): VerticalBarConfig => {
  return {
    data: [
      {
        label: '', // This Period
        value: data.current_period.total_sales / 100,
        color: '#00BC66',
        tooltext: tooltip('Sales', [
          {
            value: `${formatMoney(data.current_period.total_sales)}`,
            label: 'This Period',
          },
          {
            value: `${formatMoney(data.previous_year.total_sales)}`,
            label: 'Prev Year Avg',
          },
          {
            value: formatChangePercentage(data.previous_period.total_sales, data.current_period.total_sales),
            label: 'Change Over Last Period',
          },
          {
            value: formatMoney(data.peer_groups[peerGroupId]?.avg_total_sales),
            label: 'Peer Group Avg',
          },
        ]),
      },
      {
        label: '', // Previous Year Average
        value: data.previous_year.total_sales / 100,
        color: '#1270FC',
        tooltext: tooltip('Sales', [
          {
            value: `${formatMoney(data.current_period.total_sales)}`,
            label: 'This Period',
          },
          {
            value: `${formatMoney(data.previous_year.total_sales)}`,
            label: 'Prev Year Avg',
          },
          {
            value: formatChangePercentage(data.previous_period.total_sales, data.current_period.total_sales),
            label: 'Change Over Last Period',
          },
          {
            value: formatMoney(data.peer_groups[peerGroupId]?.avg_total_sales),
            label: 'Peer Group Avg',
          },
        ]),
      },
      {
        label: '', // Peer Group Average
        value: data.peer_groups[peerGroupId]?.avg_total_sales / 100,
        color: '#F5A623',
        tooltext: tooltip('Sales', [
          {
            value: `${formatMoney(data.current_period.total_sales)}`,
            label: 'This Period',
          },
          {
            value: `${formatMoney(data.previous_year.total_sales)}`,
            label: 'Prev Year Avg',
          },
          {
            value: formatChangePercentage(data.previous_period.total_sales, data.current_period.total_sales),
            label: 'Change Over Last Period',
          },
          {
            value: formatMoney(data.peer_groups[peerGroupId]?.avg_total_sales),
            label: 'Peer Group Avg',
          },
        ]),
      },
    ],
  };
};
